function observeFooter() {
  const footer = document.querySelector("#footer");
  const signupForm = document.querySelector(".signup-page-form");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          signupForm.classList.remove("fixed");
        } else {
          signupForm.classList.add("fixed");
        }
      });
    },
    { threshold: 0.4 }
  );
  observer.observe(footer);
}

window.addEventListener("load", () => {
  observeFooter();
});
